import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AppShell from "@/layouts/AppShell";
import Dashboard from "@/pages/Dashboard";
import NewConversation from "@/pages/NewConversation";
import Outreach from "@/pages/Outreach";
import Library from "@/pages/Library";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Chat from "@/pages/Chat";
import History from "@/pages/History";
import Objections from "@/pages/Objections";
import FollowUps from "@/pages/FollowUps";
import Extension from "@/pages/Extension";
import Billing from "@/pages/Billing";
import Team from "@/pages/Team";
import AcceptInvite from "@/pages/AcceptInvite";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

const Protected = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-zinc-400">
                Loading...
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
};

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route
                            path="/app"
                            element={
                                <Protected>
                                    <AppShell />
                                </Protected>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="new" element={<NewConversation />} />
                            <Route path="outreach" element={<Outreach />} />
                            <Route path="clients" element={<Clients />} />
                            <Route path="clients/:id" element={<ClientDetail />} />
                            <Route path="library" element={<Library />} />
                            <Route path="chat/:id" element={<Chat />} />
                            <Route path="history" element={<History />} />
                            <Route path="objections" element={<Objections />} />
                            <Route path="followups" element={<FollowUps />} />
                            <Route path="billing" element={<Billing />} />
                            <Route path="team" element={<Team />} />
                            <Route path="extension" element={<Extension />} />
                            <Route path="admin" element={<Admin />} />
                        </Route>
                        <Route path="/accept-invite/:token" element={<AcceptInvite />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster theme="dark" position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}
